import React from 'react'
import { DefaultTableCol, TeamItemCon, TmName } from './weekStyles'
import { createUrl } from '../../../../Routing/urls'
import type { EventGQL } from '../../../../Api'
import { SEASON_SEGMENT_NAMES } from '../../../../Utils'
import { Lk } from '../../../../Components/Links/Lk'
import { Img } from '../../../../Components/Image/Img'
import { getTeamImage } from '../../../../Utils/Teams/teamHelpers'
type TeamsColParams = {
  description: string
  event: EventGQL
  teamStatus: 'away' | 'home'
}

export const TeamItem: React.FC<React.PropsWithChildren<TeamsColParams>> = ({
  event,
  description,
  teamStatus,
}) => {
  if (
    (event.seasonSegment === SEASON_SEGMENT_NAMES.allStar &&
      event.slugname.includes('skill')) ||
    (event.seasonSegment === SEASON_SEGMENT_NAMES.postSeason &&
      !event?.awayTeam &&
      !event?.homeTeam)
  ) {
    return (
      <DefaultTableCol>
        <TmName justify="center">{description}</TmName>
      </DefaultTableCol>
    )
  }
  const isPLLEvent = event.league === 'PLL'
  const teamName =
    teamStatus === 'away' ? event?.awayTeam?.fullName : event?.homeTeam?.fullName
  const teamLocation =
    teamStatus === 'away' ? event?.awayTeam?.location : event?.homeTeam?.location

  return (
    <TeamItemCon justify={teamStatus === 'away' ? 'right' : 'left'}>
      {!teamName && <TmName>TBA</TmName>}
      {teamName && (
        <>
          {teamStatus === 'home' && (
            <Img
              src={getTeamImage(teamName, event?.seasonSegment, event?.year)}
              alt={`${teamName} Team logo`}
            />
          )}
          {isPLLEvent && (
            <Lk link={createUrl('teams', { id: teamName })} alt={`${teamName} team`}>
              <TmName justify={teamStatus === 'away' ? 'right' : 'left'}>
                {teamLocation || ''} {teamName}
              </TmName>
            </Lk>
          )}
          {!isPLLEvent && (
            <TmName justify={teamStatus === 'away' ? 'right' : 'left'}>
              {teamLocation || ''} {teamName}
            </TmName>
          )}
          {teamStatus === 'away' && (
            <Img
              src={getTeamImage(teamName, event?.seasonSegment, event?.year)}
              alt={`${teamName} Team logo`}
            />
          )}
        </>
      )}
    </TeamItemCon>
  )
}
